import React from 'react';
import { ArchiveRestore, ChevronDown, Lock, LockOpen, Pencil } from 'lucide-react';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { kontoAktionen, MENUE_TEXTE } from '../../lib/verwaltungskonten';

const KNOEPFE = {
  bearbeiten: { text: 'Bearbeiten', Symbol: Pencil, klasse: '' },
  sperren: { text: 'Sperren', Symbol: Lock, klasse: 'text-red-600 hover:text-red-700' },
  entsperren: { text: 'Entsperren', Symbol: LockOpen, klasse: '' },
  wiederherstellen: { text: 'Wiederherstellen', Symbol: ArchiveRestore, klasse: '' },
};

// Ausgeschriebene Knöpfe + Menü „Mehr“ nach kontoAktionen (Tabelle, Karten, Detail-Blatt).
export const KontoAktionen = ({ konto, ich, onAktion, ort = 'zeile' }) => {
  const { knoepfe, menue } = kontoAktionen(konto, ich);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`konto-aktionen-${ort}-${konto.id}`}>
      {knoepfe.map((k) => {
        const { text, Symbol, klasse } = KNOEPFE[k];
        return (
          <Button key={k} type="button" variant="outline" size="sm" className={klasse} onClick={() => onAktion(k, konto)} data-testid={`${ort}-${k}-${konto.id}`}>
            <Symbol className="mr-1.5 h-4 w-4" />{text}
          </Button>
        );
      })}
      {menue.length > 0 && (
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <Button type="button" variant="outline" size="sm" data-testid={`${ort}-mehr-${konto.id}`}>Mehr<ChevronDown className="ml-1 h-4 w-4" /></Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-64">
            {menue.map((m, i) => (m.trenner ? <DropdownMenuSeparator key={`t${i}`} /> : (
              <DropdownMenuItem key={m.key} disabled={m.deaktiviert} onSelect={() => onAktion(m.key, konto)}
                className={m.key === 'loeschen' ? 'text-red-600' : ''} data-testid={`menue-${m.key}-${konto.id}`}>
                <div className="flex flex-col">
                  <span>{MENUE_TEXTE[m.key]}</span>
                  {m.hinweis && <span className="text-xs text-slate-500">{m.hinweis}</span>}
                </div>
              </DropdownMenuItem>
            )))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};

export default KontoAktionen;
